<div cdkDropList
     (cdkDropListDropped)="drop($event)">
  <section *ngFor="let configItem of value; let i = index"
           #columnItem
           cdkDrag
           class="config-edit-area"
           [ngClass]="{'selected-column': selectedColumnIndex === i}"
           (click)="onColumnClick(i)">
    <div class="short-description">
      <div class="drag-icon">
        <i class="fa-regular fa-grip-lines"></i>
      </div>
      <div class="description">
        <span><b>Title:</b></span> {{configItem.title}}
        <span><b>Visible:</b></span> {{configItem.visible}}
      </div>
    </div>
    <div class="delete-edit-buttons"
         (click)="$event.stopPropagation()">
      <div>
        <rappider-button [icon]="deleteButtonIconConfig"
                         [size]="ButtonSize.Small"
                         popconfirmTitle="Are you sure to delete this item?"
                         [emitWithoutPopconfirm]="false"
                         (confirm)="onDeleteItemClick(i)">
        </rappider-button>
      </div>
    </div>
  </section>
</div>
